import React, { useState } from "react";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import Card from "@mui/material/Card";
import MDTypography from "components/MDTypography";
import PropTypes from "prop-types";

function ChangePasswordCard({ onChangePassword }) {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    if (newPassword !== confirmPassword) {
      setError("New passwords do not match.");
      return;
    }
    setLoading(true);
    try {
      // Replace with actual API call
      await onChangePassword(currentPassword, newPassword);
      setSuccess("Password changed successfully.");
      setCurrentPassword("");
      setNewPassword("");
      setConfirmPassword("");
    } catch (err) {
      setError(err.message || "Failed to change password.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card sx={{ p: 3, mt: 2, width: "100%" }}>
      <MDTypography variant="h6" fontWeight="medium" mb={2}>
        Change Password
      </MDTypography>
      {error && (
        <MDTypography color="error" mb={1}>
          {error}
        </MDTypography>
      )}
      {success && (
        <MDTypography color="success" mb={1}>
          {success}
        </MDTypography>
      )}
      <form onSubmit={handleSubmit}>
        <MDBox mb={2}>
          <MDInput
            type="password"
            label="Current Password"
            fullWidth
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
            required
          />
        </MDBox>
        <MDBox mb={2}>
          <MDInput
            type="password"
            label="New Password"
            fullWidth
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            required
          />
        </MDBox>
        <MDBox mb={2}>
          <MDInput
            type="password"
            label="Confirm New Password"
            fullWidth
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
          />
        </MDBox>
        <MDButton type="submit" color="info" disabled={loading}>
          {loading ? "Changing..." : "Change Password"}
        </MDButton>
      </form>
    </Card>
  );
}

ChangePasswordCard.propTypes = {
  onChangePassword: PropTypes.func.isRequired,
};

export default ChangePasswordCard;
